import { render } from "./IBall.vue?vue&type=template&id=92e1e930&ts=true"
import script from "./IBall.vue?vue&type=script&lang=ts"
export * from "./IBall.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__